import * as React from "react";
import { ListItem, styled } from "@mui/material";
import { CONDENSED_FONT } from "fe-web-components/styles/typography";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { RosebudColorMap } from "../rosebud/rosebudColorMap";
import CheckIcon from "@mui/icons-material/Check";
import { MobileView } from "../../../util/aKaunGeneralUtil";

//region [[ Styles ]]

const PatientChartSectionTitleView = styled("div")(
  ({ theme, selected }: { theme?: any; selected: boolean }) => ({
    borderLeft:
      selected === true ? "5px solid " + RosebudColorMap.green2 : "unset",

    "& .MuiListItem-root.Mui-selected": {
      backgroundColor: "white",
    },
  }),
);

const CheckIconStyled = styled(CheckIcon)({
  fontSize: "20px",
  marginRight: "8px",
  color: "green",
});

const SectionTitle = styled(ListItem)(
  ({ theme, selected }: { theme?: any; selected: boolean }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    cursor: "pointer",
    color: "black",
    textTransform: "capitalize",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingLeft: !selected ? theme.spacing(2) : theme.spacing(1.5),
    paddingRight: theme.spacing(1),
    fontFamily: CONDENSED_FONT,
    fontWeight: 500,
    fontSize: "20px",
    "&:hover": {
      backgroundColor: "rgb(218, 220, 224, 0.5)",
    },
    borderColor: KahunColorMap.Primary,

    [theme.breakpoints.down(MobileView)]: {
      fontSize: "16px",
      paddingLeft: "0px",
      paddingRight: "0px",
      fontWeight: 700,
    },
  }),
);

const Title = styled("span")(({ theme }) => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientChartSectionTitleProps {
  titleText: string;
  onClick: () => void;
  selected?: boolean;
  showCheck?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientChartSectionTitle = ({
  titleText,
  onClick,
  selected,
  showCheck,
}: PatientChartSectionTitleProps) => {
  return (
    <PatientChartSectionTitleView selected={selected}>
      <SectionTitle onClick={onClick} selected={selected}>
        <Title>{titleText}</Title>
        {showCheck === true && <CheckIconStyled />}
      </SectionTitle>
    </PatientChartSectionTitleView>
  );
};
